<script setup>
import {Link} from '@inertiajs/vue3';

const props = defineProps({
    href: {
        type: String,
        required: true,
    },
    symbol: {
        type: String,
        default: '→',
    }
});

</script>

<template>
    <Link :href="href"
          class="inline-block whitespace-nowrap rounded-full bg-white px-4 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
        <slot/>
        <span aria-hidden="true" class="ml-1" v-if="symbol">{{ symbol }}</span>
    </Link>
</template>
